import { render, staticRenderFns } from "./EnhancedNetworkCard.vue?vue&type=template&id=2b29f0ed&scoped=true"
import script from "./EnhancedNetworkCard.vue?vue&type=script&lang=js"
export * from "./EnhancedNetworkCard.vue?vue&type=script&lang=js"
import style0 from "./EnhancedNetworkCard.vue?vue&type=style&index=0&id=2b29f0ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b29f0ed",
  null
  
)

export default component.exports